export default class Mask {
  init() {
    $('.masked-zipcode').mask('00000');
    $('.ssn').mask('000-00-0000');
    $('.ein').mask('00-0000000');
    $('.masked-date').mask('00/00/0000');
    $('.masked-date-month').mask('00/0000');
    $('.masked-day-month').mask('00/00');
    $('.masked-phone').mask('(000) 000-0000');
    $('.masked-pin').mask('0000');
    $('.jquery-datepicker').datepicker();
    $(document).on('focus', '.datepicker', function () {
      setTimeout(function () { $('.datepicker-container').addClass('fs-ignore-rage-clicks') }, 0);
    });
    $('[data-toggle="tooltip"]').tooltip();
    $('.routing-number').mask('000000000');
    $('.account-number').on('input', function () {
      this.value = this.value.replace(/[\s-]/g, '');
    });

    // Select2
    const $tagList = $('#group_notebook_attributes_tag_list');
    if ($tagList.length > 0 && typeof $tagList.select2 === 'function') {
      $tagList.select2();
    }
  }
}
